<template>
    <div id="recaptcha" class="row" v-if="!isLoading">
        <div class="col-12 captcha-wrapper justify-content-center">
            <vue-recaptcha ref="recaptcha" class="recaptcha-component" :sitekey="sitekey" :loadRecaptchaScript="true" @verify="verifyEvent"></vue-recaptcha>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState, mapActions } from "vuex";

export default {
    name: "recaptcha",
    data() {
        return {
            sitekey: "6Le4ZsMcAAAAAMa23dn0IK9ikEkbg60w72wQkggh",
        };
    },
    components: {
        "vue-recaptcha": VueRecaptcha,
    },
    computed: {
        ...mapState("willyou", ["loadReCaptcha", "baseApiUrl", "isLoading"]),
    },
    methods: {
        ...mapActions("willyou", {
            checkCaptcha: "checkCaptcha",
        }),
        verifyEvent(response) {
            response ? this.checkCaptcha(response) : null;
            this.$emit("reloadComponent");
        },
    },
};
</script>

<style lang="scss" scoped>
#recaptcha {
    .captcha-wrapper {
        display: flex;
        padding: 75px 0;
        div {
            display: inline-block;
        }
    }
}
</style>
